import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface UseDeleteEstablishmentLeadGenericDocumentProps {
  establishmentLeadId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useDeleteEstablishmentLeadGenericDocument = ({ establishmentLeadId, onSuccess, onError }: UseDeleteEstablishmentLeadGenericDocumentProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['deleteEstablishmentLeadGenericDocument'],
    mutationFn: (attachment_id: string) => {
      const lead = {
        generic_documents_attachments_attributes: [
          {
            id: attachment_id,
            _destroy: true,
          }
        ]
      }

      return privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}